import React, { Component } from "react";
import { connect } from 'react-redux';

class LoadingOverlay extends Component {
    render() {
        const { isLoading } = this.props;

        let displayOverlay = "none";

        if (isLoading) {
            displayOverlay = "inline";
        }

        return (
            <div className="overlay" style={{ display: displayOverlay }}>
                <div className="text-center loadingFontBig">
                    <i className="fa fa-cog"></i>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    isLoading: state.reducer.isLoading
});

export default connect(mapStateToProps)(LoadingOverlay);


// WEBPACK FOOTER //
// ./src/components/containers/LoadingOverlay.js